import { render, staticRenderFns } from "./InfoDocument.vue?vue&type=template&id=dea18982&scoped=true"
import script from "./InfoDocument.vue?vue&type=script&lang=js"
export * from "./InfoDocument.vue?vue&type=script&lang=js"
import style0 from "./InfoDocument.vue?vue&type=style&index=0&id=dea18982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea18982",
  null
  
)

export default component.exports